module.exports = __webpack_public_path__ + "static/img/wire_landing_08.5ba37dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wire_landing_08.jpg
// module id = A6ZV
// module chunks = 0